import React, { useState, useRef } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Menu,
  MenuItem,
  Toolbar,
  TextField,
  Typography,
  Tooltip
} from "@material-ui/core";
import { ACCESS } from "../../../data";
import { PersonAdd } from '@material-ui/icons';
import ModalPrompt from "./ModalPrompt";
import { Auth } from 'aws-amplify';
import { host } from "../../../data";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '38px',
    marginBottom: theme.spacing(2),
  },
  selectedLabel: {
    width: '100',
    fontSize: 20,
    color: theme.palette.primary.light,
  },
  selectedName: {
    width: '100',
    fontSize: 20,
    marginLeft: theme.spacing(2),

  },
  deleteButton: {
    marginLeft: theme.spacing(2),
  },
  Button: {
    margin: theme.spacing(1),
  },
  grow: {
    flexGrow: 1,
  }
}));

const ItemDelete = ({ access, selected = {}, action, inviteUser, allowItemDelete, moveDestinations, handleMove }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => setOpenDialog(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const deleteObj = () => {
    setOpenDialog(true);
  };
  const handleAction = () => {
    if (selected.type === 'BRANCH' || selected.type === 'SITE' || selected.type === 'ORG') {
      action(selected);
    }
    setOpenDialog(false);
  };

  // Create state for the invites
  const [inviteOpen, setInviteOpen] = useState(false);
  const recipient = useRef("");

  const handleInviteOpen = () => {
    setInviteOpen(true);
  };

  const handleInviteClose = () => {
    setInviteOpen(false);
  };

  // Functions to handle invitations
  const handleInvite = async (permissions) => {
    const l_recipient = recipient.current.value;
    inviteUser(selected, l_recipient, permissions);
    setInviteOpen(false);
  };

  //console.log(selected);
  const closeMoveMenu = () => {
    setAnchorEl(null);
  };
  const handleMoveMenu = (target) => {
    console.log(target);
    setAnchorEl(null);
    handleMove(target.id, selected);
  };

  return (
    <div className={classes.root}>
      {(access === ACCESS.OWNER) &&
        <Toolbar >
          <Typography className={classes.selectedLabel}>
            {selected.type === 'ORG' ? t("organizationName")+": " 
              : selected.type === 'BRANCH' ? t('branchName')+": " 
              : selected.type === 'SITE' ? t("siteName") + ': ' 
              : t("tankName") + ': '}
          </Typography>
          <Typography className={classes.selectedName}>
            {selected.name}
          </Typography>
          {(selected.type === 'BRANCH' || selected.type === 'SITE' || selected.type === 'ORG') && allowItemDelete && <Tooltip title={t("delete") + " " + selected.name}>
            <IconButton className={classes.deleteButton} aria-label="delete" onClick={deleteObj}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>}

          {(selected.type === 'TANK') && <Button className={classes.Button} variant="outlined" color="primary" onClick={handleClick}>
            {t('move_caps')}
          </Button>}
          <Menu
            id="navigation-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={closeMoveMenu} >
            {moveDestinations.map((destination) => (
              <MenuItem key={destination.id} value={destination.name} onClick={() => handleMoveMenu(destination)}>
                {destination.name}
              </MenuItem>
            ))}
          </Menu>

          <div className={classes.grow} />
          {(selected.type === 'BRANCH' || selected.type === 'SITE' || selected.type === 'ORG') && <Tooltip title={t('invite')}>
            <IconButton aria-haspopup='true'
              color='inherit'
              className={classes.iconButtons}
              onClick={handleInviteOpen}>
              <PersonAdd />
            </IconButton>
          </Tooltip>}
        </Toolbar>
      }
      {openDialog && <ModalPrompt title={t('delete') + ' ' + (selected.type ? t(selected.type.toLowerCase()).toLowerCase() : '') + ' ' + selected.name + '?'}
        content={t("deleteWarning")}
        action={t("delete")}
        handleAction={handleAction}
        handleCancel={handleClose}
        openModal={openDialog}
        useConfirm={true} />}
      <Dialog open={inviteOpen} onClose={handleInviteClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{t("invite")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("toInviteAUser")}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            inputRef={recipient}
            label={t("emailAddress")}
            type="email"
            fullWidth />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleInviteClose} color="primary">
            {t("cancel")}
          </Button>
          <Button onClick={() => handleInvite("Viewer")} variant="contained" color="primary">
            {t("asViewer")}
          </Button>
          <Button onClick={() => handleInvite("Editor")} variant="contained" color="primary">
            {t("asEditor")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ItemDelete;
